// extracted by mini-css-extract-plugin
export default {"sliderWrap":"PointCarousel_sliderWrap__XDiP5"};